import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';


export default function AgentMemberShipRequestList(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmAcceptVisible, setConfirmAcceptVisible] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [sharePercent, setSharePercent] = useState(25);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    useEffect(() => {
      setLoading(true);
      

      var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, searchText:"", fromDate:0, toDate:0};
      var url = config.Server+`/user/agent/membership-request/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }, []);

    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }
    const onRowAcceptClick = function(row) {
      setCurrentItem(row);
      setConfirmAcceptVisible(true);
    }

    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/user/agent/membership-request/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmAcceptVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    const onAcceptConfirm_Accept = function(){
      setEditFormVisible(true);
    }
    const onAcceptConfirm_Reject = function(){
        if(deleting) return;
        setConfirmAcceptVisible(false);
    }
    const saveItem = function(){
      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var params = {login:util.getTrustedUser(), id:id, sharePercent:sharePercent};
      var url = config.Server+`/user/agent/membership-request/accept`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  setEditFormVisible(false);
                  
                  setSaving(false);
                  setConfirmAcceptVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const setRowActions = function(row) {
        return (
            <React.Fragment>
                <Button icon="pi pi-check" rounded severity="success" size="small"  style={{ margin: "0px 3px" }} onClick={() => onRowAcceptClick(row)} title="تایید" />
                <Button icon="pi pi-times" rounded severity="danger" size="small"  style={{ margin: "0px 3px" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </React.Fragment>
        );
    }

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "sharePercent") {
            if(val == null) val = "0";
            if(val == "") val = "0";
            setSharePercent(parseInt(val));
        }
    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }

    return(      
      <>   
       <div className="card">
          <div className="page-caption">لیست درخواست های نمایندگی فروش</div>
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>                
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown "
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field="nationalId" header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                        <Column field="firstname" header={"نام"} sortable className="list-cell-text-align"></Column>
                        <Column field="lastname" header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                        <Column field="mobile" header={"موبایل"} sortable className="list-cell-text-align"></Column>
                        <Column field="province" header={"استان"} sortable className="list-cell-text-align"></Column>
                        <Column field="city" header={"شهر"} sortable className="list-cell-text-align"></Column>
                        <Column field="requestDate" header={"تاریخ درخواست"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row) => setRowActions(row)} exportable={false} style={{ maxWidth: '6rem' }}></Column>
                </DataTable>
              </>
          }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت مشخصات نماینده" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={sharePercent} onChange={(e)=>{onInputChange(e, "sharePercent")}} id="code" keyfilter="int" maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">درصد سهم نماینده</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>

                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      <ShowConfirm visible={confirmAcceptVisible} message="آیا از تایید مطمئن هستید؟" caption="اطمینان از تایید" onAccept={onAcceptConfirm_Accept} onReject={onAcceptConfirm_Reject} loading={deleting} />
      </>  
    );
}
